// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBT-uGCCCZ_pFQrTg0XsSMXVSrkVxIrXFE",
  authDomain: "diecastzone-d4107.firebaseapp.com",
  projectId: "diecastzone-d4107",
  storageBucket: "diecastzone-d4107.firebasestorage.app",
  messagingSenderId: "872720134434",
  appId: "1:872720134434:web:464d0e52473a90e458757b",
  measurementId: "G-BZSW86BD5T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const analytics = getAnalytics(app);
